// src/components/DateTimePicker.jsx
import React, { useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import { fr } from 'date-fns/locale'
import 'react-day-picker/dist/style.css';

function roundToNextFive(date) {
  const rounded = new Date(date);
  rounded.setSeconds(0, 0);

  const minutes = rounded.getMinutes();
  const remainder = minutes % 5;

  if (remainder !== 0) {
    rounded.setMinutes(minutes + (5 - remainder));
  }

  return rounded;
}

export default function DateTimePicker({ initialValue = null, onConfirm, onCancel }) {
  const [selectedDate, setSelectedDate] = useState();
  const [hour, setHour] = useState('00');
  const [minute, setMinute] = useState('00');

  useEffect(() => {
    let base;
    if (initialValue) {
      base = roundToNextFive(new Date(initialValue));
    } else {
      base = roundToNextFive(new Date());
    }

    setSelectedDate(base);
    setHour(base.getHours().toString().padStart(2, '0'));
    setMinute(base.getMinutes().toString().padStart(2, '0'));
  }, [initialValue]);

  const handleConfirm = () => {
    if (!selectedDate) return;

    const final = new Date(selectedDate);
    final.setHours(Number(hour));
    final.setMinutes(Number(minute));
    final.setSeconds(0, 0);

    onConfirm?.(final);
  };
  return (
    <div className="w-80 rounded-xl bg-white p-4 shadow-xl border border-gray-200 space-y-4">
      <DayPicker
        mode="single"
        selected={selectedDate}
        onSelect={setSelectedDate}
        locale={fr}
        classNames={{
          today: 'text-red-500',
          selected: 'ring-2 ring-red-500 rounded-[100px]',
          chevron: 'fill-red-600'
        }}
      />

      <div className="flex items-center justify-center gap-2">
        <select
          value={hour}
          onChange={(e) => setHour(e.target.value)}
          className="w-20 rounded-lg border px-3 py-2 text-center
                     focus:ring-2 focus:ring-red-500"
        >
          {Array.from({ length: 24 }, (_, i) => {
            const val = i.toString().padStart(2, '0');
            return (
              <option key={val} value={val}>
                {val}
              </option>
            );
          })}
        </select>

        <span className="text-lg font-medium">:</span>

        <select
          value={minute}
          onChange={(e) => setMinute(e.target.value)}
          className="w-20 rounded-lg border px-3 py-2 text-center
                     focus:ring-2 focus:ring-red-500"
        >
          {Array.from({ length: 12 }, (_, i) => {
            const val = (i * 5).toString().padStart(2, '0');
            return (
              <option key={val} value={val}>
                {val}
              </option>
            );
          })}
        </select>
      </div>

      <div className="flex justify-end gap-2 pt-2">
        <button
          onClick={onCancel}
          className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition"
        >
          Annuler
        </button>

        <button
          onClick={handleConfirm}
          className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
        >
          Confirmer
        </button>
      </div>
    </div>
  );
}